export const config = {
  prodDomain: 'https://www.pros-cons-list.com',
}
